// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"28":"poster","193":"interactive","499":"presentation","884":"videoVideoJs"}[chunkId] + "." + {"28":"f20fb413","193":"32fcae8d","499":"46e221e8","884":"6cbbb044"}[chunkId] + ".js";
};